import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=2ce8a3c9&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=ts"
export * from "./EditButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8a3c9",
  null
  
)

export default component.exports